import { render, staticRenderFns } from "./LoaderPayment.vue?vue&type=template&id=4b5f80f3&scoped=true"
import script from "./LoaderPayment.vue?vue&type=script&lang=js"
export * from "./LoaderPayment.vue?vue&type=script&lang=js"
import style0 from "./LoaderPayment.vue?vue&type=style&index=0&id=4b5f80f3&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5f80f3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.ideabuddy.com/public_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b5f80f3')) {
      api.createRecord('4b5f80f3', component.options)
    } else {
      api.reload('4b5f80f3', component.options)
    }
    module.hot.accept("./LoaderPayment.vue?vue&type=template&id=4b5f80f3&scoped=true", function () {
      api.rerender('4b5f80f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LoaderPayment.vue"
export default component.exports